<template>
<div class="">
  <div class="margin-page box-content shadow-box hidden animation-bottom animation-delay-01 container column" v-if="hasBook && hasUnits">
    <!-- <titleComponent :mark="`book ${book.title.replace('Book ', '').toLowerCase()}`" value="<b>UNIDADE</b> ATUAL" color="background-red" button="Exibir todas unidades" :showTimer="true" :showOnlineClass="true"/> -->
    <titleComponent :mark="`book ${currentBook.title.replace('Book ', '').toLowerCase()}`" value="<b>UNIDADE</b> ATUAL" color="background-red" button="Exibir todas unidades" :showTimer="true" :showOnlineClass="student.test_mode"/>
    <currentUnit :data="currentUnit" />
  </div>
  <div class="box-content shadow-box hidden animation-bottom animation-delay-01 container justify-content-center color-red" v-else-if="hasBook && !hasUnits">
    <div class="item">
      <h3>No Units in Library :(</h3>
    </div>
  </div>

  <div class="box-content shadow-box hidden animation-bottom animation-delay-01 container justify-content-center color-red" v-else-if="!hasBook && !hasUnits">

    <div id="alert" class="container item full-width">
      <div id="msg" class="boxmsg">
        <h1><span/> Attention!</h1>
        <h2>No Books in Library!</h2>
      </div>
      <div id="desc" class="boxmsg">
        <img src="@/assets/img/icons/blockdash/book.svg" height="60px" alt="Attention">
        <h3 class="container">Você ainda não possui nenhum conteúdo cadastrado. Adicione usando o token impresso na capa do livro.</h3>
      </div>
      <div id="warn" class="boxmsg" style="cursor: pointer;" @click="$router.push({ name: 'books' })">Add your first book</div>
    </div>
  </div>

  <div class="box-content shadow-box hidden animation-bottom animation-delay-02">
    <titleComponent mark="Presencial" value="<b>PRÓXIMA</b> AULA" color="background-orange container column" :calendar="true" :titleBtn="!isClassScheduled" :btnAction="() => showSchedule = true"/>
    <vue-event-calendar :events="classes" @day-changed="handleDayChanged" :local="locale" @month-changed="handleMonthChanged"/>
  </div>
  <transition name="show-schedule">
    <div class="schedule__menu padding-20 container justify-center align-center" v-if="showSchedule" @click="showSchedule = false">
      <font-awesome-icon class="schedule__menu__icon" icon="times" @click="showSchedule = false"/>
      <scheduleClass :close="() => showSchedule = false"/>
    </div>
  </transition>
</div>
</template>

<script type="text/javascript">
import titleComponent from '@/components/titleComponent'
import currentUnit from './currentUnit'
import scheduleClass from '@/components/scheduleClass'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      locale: 'pt-br',
      showSchedule: false
    }
  },
  computed: {
    ...mapGetters({
      books: 'book/getAll',
      book: 'book/get',
      bookExists: 'book/exists',
      unit: 'unit/get',
      classes: 'lesson/getClasses',
      isClassScheduled: 'lesson/isClassScheduled',
      student: 'student/GET',
      teensBooks: 'teens/GET_BOOKS',
      teensBook: 'teens/GET_CURRENT_BOOK',
      teensUnits: 'teens/GET_UNITS',
      teensUnit: 'teens/GET_CURRENT_UNIT',
    }),
    currentBook () {
      if (!this.student.teens)
        return this.book

      return this.teensBook
    },
    currentUnit () {
      if (!this.student.teens)
        return this.unit

      return this.teensUnit
    },
    hasUnits () {
      if (!this.hasBook) return false

      if (!this.student.teens)
        return !this.book.units ? false : Object.keys(this.book.units).length > 0

      return !!this.teensUnits.length
    },
    hasBook () {
      if (!this.student.teens)
        return this.bookExists
      
      return !!this.teensBooks.length
    }
  },
  components: {
    titleComponent,
    currentUnit,
    scheduleClass
  },
  methods: {
    handleDayChanged (data) {},
    handleMonthChanged (data) {}
  },
  async beforeMount () {
    this.$store.commit('setShowLoader', true)
    await this.$store.dispatch('book/setBook')
    await this.$store.dispatch('unit/setUnit')
    this.$store.commit('setShowLoader', false)
  }
}
</script>

<style lang="scss">
@import './src/assets/css/components/calendar';

.item{
  flex-wrap: wrap;
  &#alert {
    align-items: center;
  }
  div#msg:nth-child(1) {
    flex-direction: column;
    align-items: flex-end;
    @media (max-width: 440px){
      align-items: center;
    }
  }
  div#desc:nth-child(2) {
    flex-direction: row;
    align-items: center;
  }
  div#warn:nth-child(3) {
    font-weight: 300;
    text-transform: uppercase;
    background: linear-gradient(-5deg, #0073b8, #00e7ff) !important;
    justify-content: center;
    align-items: center;
    border-radius: 300px;
    color: white;
    height: 40px!important;
    margin: 10px 20px 10px 20px;
  }
  .boxmsg {
    display: flex;
    justify-content: center;
    flex-grow: 1;
    flex-basis: 50%;
    height: 70px;

    h1 {
      font-size: 25px;
      font-weight: 400;
      text-transform: uppercase;
      color: orange;
      display: flex;
      align-items: center;
      span{
        height: 7px;
        width: 205px;
        background-color: orange;
        border-radius: 300px;
        margin: 0px 10px 0px 0px;
        @media (max-width: 440px){
          width: 150px;
        }
      }
    }
    h2 {
      font-size: 35px;
      font-weight: 400;
      letter-spacing: -1px;
      text-transform: uppercase;
      @media (max-width: 440px){
          font-size: 30px;
        }
    }
    h3 {
      font-size: 15px;
      font-weight: 200;
      color: gray;
      align-items: center;
      padding-right: 25px;
      @media (max-width: 440px){
          font-size: 13px;
        }
    }
    img {
      width: 70px;
      margin: 0px 5px 0px 20px;
      @media (max-width: 440px){
          margin: 0px 5px 0px 0px;
        }
    }
  }
}

.schedule__menu {
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(19, 0, 0, 0.95);
  width: 100vw;
  height: 100%;
  z-index: 150;
  &__icon {
    position: absolute;
    top: 5vh;
    right: 5vw;
    height: 60px !important;
    width: 60px !important;
    color: #fc7f7f;
    transition: transform .2s;
    cursor: pointer;
    &:hover {
      transform: scale(1.2) rotate(90deg);
    }
  }
}

.show-schedule {
  &-enter-active {
    animation: opaque .2s ease backwards;
    animation-delay: .2s;
  }
  &-leave-active {
    animation: opaque .2s ease reverse backwards;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/index.vue